<template>
  <div class="tw-flex">
    <base-icon class="tw-h-8 tw-w-8 tw-my-auto" color="primary" @click="changeCredits(-1)"><minus-icon class="tw-h-8 tw-w-8"/></base-icon>
    <base-text-field class="tw-mx-4 tw-w-24" :value="value" type="number" @input="$emit('input', $event)" />
    <base-icon class="tw-h-8 tw-w-8 tw-my-auto" color="primary" @click="changeCredits(1)"><plus-icon class="tw-h-8 tw-w-8"/></base-icon>
  </div>
</template>

<script>
import { PlusIcon, MinusIcon } from "@/assets/svgs";

export default {
  components: { PlusIcon, MinusIcon },
  props: {
    value: [String, Number],
    allowNegative: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    changeCredits(value) {
      this.$emit("input", +this.value + value);
    },
  },
};
</script>
